import { GLOBAL_CONFIG } from '../constants/global.config'
import { DomainConfig } from '../types'

const config: DomainConfig = {
  ...GLOBAL_CONFIG,
  APP_KEY: 'BWN',
  CLIENT_ID: '1',
  COUNTRY: 'zw'
}

export default config
